import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography, UtpCardSection } from 'common/components';
import { WINDOWS_ELEMENT_BLOCK } from '../../windows-constants';
import { getWindowsUtpCardList } from './windows-utp-card-section-constants';

type WindowsUtpCardSectionProps = {
  onConsultationSignupBtnClick: () => void;
};

export const WindowsUtpCardSection = ({ onConsultationSignupBtnClick }: WindowsUtpCardSectionProps) => {
  const { t } = useTranslation();

  return (
    <UtpCardSection
      elementBlock={WINDOWS_ELEMENT_BLOCK}
      elementText="Проектирование в Лемана ПРО"
      renderModalContent={(
        { elementName, elementText, header, modalDescription, modal: { content: CustomModalContent } = {} },
        onCloseModal
      ) => (
        <>
          <ModalHeader title={header.title} />
          {CustomModalContent ?
            <CustomModalContent />
            : (
              <ModalContent>
                <Typography variant="m" size="body_long">
                  {modalDescription}
                </Typography>
              </ModalContent>
            )
          }
          <ModalFooter>
            <ButtonWithGAClickButton
              elementBlock={WINDOWS_ELEMENT_BLOCK}
              elementName={t('utp-section.modal-button')}
              elementText={elementText || elementName}
              onClick={() => {
                onCloseModal();
                onConsultationSignupBtnClick();
              }}
              wide>
              {t('utp-section.modal-button')}
            </ButtonWithGAClickButton>
          </ModalFooter>
        </>
      )}
      title={t('utp-section.title') || ''}
      utpCardList={getWindowsUtpCardList(t)}
    />
  );
}
